import './SortOptions.css';

interface SortOptionsProps {
  sortBy: 'date' | 'price' | 'popularity' | 'name';
  sortOrder: 'asc' | 'desc';
  onSortChange: (sortBy: 'date' | 'price' | 'popularity' | 'name', sortOrder: 'asc' | 'desc') => void;
}

const sortOptions = [
  { value: 'date', label: '最新上架' },
  { value: 'price', label: '價格' },
  { value: 'popularity', label: '人氣' },
  { value: 'name', label: '名稱' },
] as const;

const SortOptions: React.FC<SortOptionsProps> = ({
  sortBy,
  sortOrder,
  onSortChange,
}) => {
  const handleSortByChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const newSortBy = e.target.value as 'date' | 'price' | 'popularity' | 'name';
    onSortChange(newSortBy, sortOrder);
  };

  const handleSortOrderToggle = () => {
    const newSortOrder: 'asc' | 'desc' = sortOrder === 'asc' ? 'desc' : 'asc';
    onSortChange(sortBy, newSortOrder);
  };

  const getSortOrderIcon = () => {
    return sortOrder === 'asc' ? '↑ 低→高' : '↓ 高→低';
  };

  return (
    <div className="sort-options">
      <label className="sort-options__label">排序</label>
      <div className="sort-options__controls">
        <select
          className="sort-options__select"
          value={sortBy}
          onChange={handleSortByChange}
        >
          {sortOptions.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
        <button
          className="sort-options__toggle"
          onClick={handleSortOrderToggle}
          type="button"
        >
          {getSortOrderIcon()}
        </button>
      </div>
    </div>
  );
};

export default SortOptions;
